import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import ScrollReveal from "scrollreveal";
import line from "../../assets/line.webp";
import divImageAR from "../../assets/programs-avatar.webp";
import divImageEN from "../../assets/programs avatar (2).png";
import trueSign from "../../assets/trueSign.webp";
import styles from "./OurPrograms.module.css";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { LazyLoadImage } from "react-lazy-load-image-component";

function OurPrograms() {
    const screenWidth = window.innerWidth;
    const { t } = useTranslation();
    const imageRef = useRef(null);
    useEffect(() => {
        const sr = ScrollReveal();
        sr.reveal(imageRef.current, {
            duration: 500,
            distance: screenWidth < 768 ? "0px" : "100px",
            easing: "ease-in",
            origin: "left",
            reset: false,
        });
        //eslint-disable-next-line
    }, []);
    return (
        <>
            <div className="d-flex flex-column justify-around-center align-items-center">
                <h2 className={styles.ourProgramsTitle}>{t("Our_programs")}</h2>
                <LazyLoadImage
                    src={line}
                    alt="underline"
                    className={`${styles.lineWeb} ${styles.lineMobile} `}
                    ref={imageRef}
                />
            </div>
            <div
                // mx-3
                className={`${styles.ourProgramContainer} d-flex justify-content-around align-items-center m-auto`}
                style={{ width: "90%" }}
            >
                <div className="mt-3">
                    <h4 className={styles.ourProgramsSectionTitle}>
                        {t("Our programs are distinguished as:")}
                    </h4>
                    <ul className="p-0 mt-4">
                        <li className="mt-4">
                            <LazyLoadImage src={trueSign} className="mx-2" alt="truesign" />
                            {t("Fully supported training programs")}
                        </li>
                        <li className=" mt-4">
                            <LazyLoadImage src={trueSign} className="mx-2" alt="truesign" />
                            {t(
                                "Accredited and international certificates in cooperation with partners"
                            )}
                        </li>
                        <li className="mt-4">
                            <LazyLoadImage src={trueSign} className="mx-2" alt="truesign" />
                            {t("More than 14 countries in the Arab world")}
                        </li>
                    </ul>
                    <div className="w-75 me-4">
                        <p className={styles.ourProgramsObj}>
                            {t(
                                "Our programs are provided with international, local partners and governmental entities"
                            )}
                        </p>
                    </div>
                    <div className="d-flex justify-content-center">
                        <Link to="/programs">
                            <button
                                aria-label="button to be clicked"
                                aria-labelledby="button to be clicked"
                                className={`btn btn-primary ${styles.btn_show_programs}`}
                            >
                                {t("View training programs")}
                            </button>
                        </Link>
                    </div>
                </div>
                <div className={styles.ourProgramsImg}>
                    <LazyLoadImage
                        src={i18next.language === "ar" ? divImageAR : divImageEN}
                        alt="our-programs"
                    />
                </div>
            </div>
        </>
    );
}

export default OurPrograms;
